import type { CookieConsentConfig } from "vanilla-cookieconsent";

const getConfig = () => {
  const config: CookieConsentConfig = {
    // root: 'body',
    // autoShow: true,
    // disablePageInteraction: true,
    // hideFromBots: true,
    // mode: 'opt-in',
    // revision: 0,

    cookie: {
      // name: 'cc_cookie',
      // domain: location.hostname,
      // path: '/',
      // sameSite: "Lax",
      // expiresAfterDays: 365,
    },

    /**
     * Callback functions
     */
    onFirstConsent: ({ cookie }) => {
      // console.log("onFirstConsent fired", cookie);
    },

    onConsent: ({ cookie }) => {
      // console.log("onConsent fired!", cookie);
    },

    onChange: ({ changedCategories, changedServices }) => {
      // console.log("onChange fired!", changedCategories, changedServices);
    },

    onModalReady: ({ modalName }) => {
      // console.log("ready:", modalName);
    },

    onModalShow: ({ modalName }) => {
      // console.log("visible:", modalName);
    },

    onModalHide: ({ modalName }) => {
      // console.log("hidden:", modalName);
    },

    // https://cookieconsent.orestbida.com/reference/configuration-reference.html#guioptions
    guiOptions: {
      consentModal: {
        layout: "box inline",
        position: "bottom left",
        equalWeightButtons: true,
        flipButtons: false,
      },
      preferencesModal: {
        layout: "box",
        equalWeightButtons: true,
        flipButtons: false,
      },
    },

    categories: {
      necessary: {
        enabled: true, // this category is enabled by default
        readOnly: true, // this category cannot be disabled
      },
      analytics: {
        autoClear: {
          cookies: [
            {
              name: /^_ga/, // regex: match all cookies starting with '_ga'
            },
            {
              name: "_gid", // string: exact cookie name
            },
          ],
        },

        // https://cookieconsent.orestbida.com/reference/configuration-reference.html#category-services
        services: {
          googleAds: {
            label: "Google Ads",
            onAccept: () => {
              if (window?.gtag) {
                console.log("updated consent for googleAds");
                window.gtag("consent", "update", {
                  ad_storage: "granted",
                });
              } else {
                console.log("Failed to update consent");
              }
            },
            onReject: () => {
              if (window?.gtag) {
                window.gtag("consent", "update", {
                  ad_storage: "denied",
                });
              }
            },
          },
          ga: {
            label: "Google Analytics",
            onAccept: () => {
              if (window?.gtag) {
                console.log("updated consent for google analytics");
                window.gtag("consent", "update", {
                  analytics_storage: "granted",
                });
              } else {
                console.log("Failed: updated consent for google analytics");
              }
            },
            onReject: () => {
              if (window?.gtag) {
                window.gtag("consent", "update", {
                  analytics_storage: "denied",
                });
              }
            },
          },
          youtube: {
            label: "Youtube Embed",
            onAccept: () => {},
            onReject: () => {},
          },
        },
      },
      ads: {},
    },

    language: {
      default: "sv",
      translations: {
        sv: {
          consentModal: {
            title: "Vi använder cookies",
            description:
              "Vi använder oss av cookies för att analysera vår trafik, förbättra din upplevelse samt för att anpassa innehåll och marknadsföring för dig via våra partners",
            acceptAllBtn: "Acceptera alla",
            acceptNecessaryBtn: "Avvisa alla",
            showPreferencesBtn: "Hantera individuella inställningar",
            // closeIconLabel: 'Reject all and close modal',
            // footer: `
            //             <a href="#path-to-impressum.html" target="_blank">Impressum</a>
            //             <a href="https://smartywak.com/cookie-policy/" target="_blank">Privacy Policy</a>
            //         `,
            footer: `
                        <a href="mailto:hello@smartywak.com" target="_blank">Contact Us</a>
                    `,
          },
          preferencesModal: {
            title: "Manage cookie preferences",
            acceptAllBtn: "Accept all",
            acceptNecessaryBtn: "Reject all",
            savePreferencesBtn: "Accept current selection",
            closeIconLabel: "Close modal",
            serviceCounterLabel: "Service|Services",
            sections: [
              {
                title: "Your Privacy Choices",
                description: `In this panel you can express some preferences related to the processing of your personal information. You may review and change expressed choices at any time by resurfacing this panel via the provided link. To deny your consent to the specific processing activities described below, switch the toggles to off or use the “Reject all” button and confirm you want to save your choices.`,
              },
              {
                title: "Strictly Necessary",
                description:
                  "These cookies are essential for the proper functioning of the website and cannot be disabled.",

                //this field will generate a toggle linked to the 'necessary' category
                linkedCategory: "necessary",
              },
              {
                title: "Performance and Analytics",
                description:
                  "These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.",
                linkedCategory: "analytics",
                cookieTable: {
                  caption: "Cookie table",
                  headers: {
                    name: "Cookie",
                    domain: "Domain",
                    desc: "Description",
                  },
                  body: [
                    {
                      name: "_ga",
                      domain: location.hostname,
                      desc: `Detta är en webbanalystjänst. Med detta kan användaren mäta annonsens avkastning på investeringen "ROI" samt spåra användarbeteende med flash, video, webbplatser ochapplikationer.`,
                    },
                    {
                      name: "_gid",
                      domain: location.hostname,
                      desc: "Description 2",
                    },
                  ],
                },
              },
              {
                title: "Targeting and Advertising",
                description:
                  "These cookies are used to make advertising messages more relevant to you and your interests. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.",
                linkedCategory: "ads",
              },
              {
                title: "More information",
                description:
                  'For any queries in relation to my policy on cookies and your choices, please <a href="mailto:hello@smartywak.com">contact us</a>',
              },
            ],
          },
        },
      },
    },
  };

  return config;
};

export default getConfig;
